<template>
    <div style="height: 93vh;">

        <b-container v-if="selLanguages" fluid style="height:100%;min-height: 100%;position:relative;">
            
            <b-row id="content">
                    <div v-if="content === 'mappa'" style="height: 100%; width: 100%;">

                        <div v-if="!dest_lang" style="height: 100%;" class="d-flex align-items-center">
                            <div class="box" style="width: 100%;">
                            <h2 style="color: orange; font-weight: bold;">Seleziona la tua lingua</h2>
                            <v-select style="margin: auto; width: 60%; background-color: white;"
                            :options="langs" v-model="dest_lang" @input="setUserStorageLanguage" label="description" name="langs" placeholder="Seleziona la tua lingua"></v-select>
                            </div>
                        </div>

                        <div v-else style="height: 100%;">

                            <div v-if="!hidden" class="mappa">
                                <div id="v-select" style="z-index: 1;" >
                                    <h1 class="text-left" style="color: orange; cursor:pointer;" @click="resetDestLang"><font-awesome-icon style="font-size: 30px;" icon="chevron-left" /> Indietro</h1>
                                </div>

                                <panZoom style="z-index: 0; overflow: hidden; height: calc(93vh - 3.2rem);" :options="{minZoom: 0.5, maxZoom: 2, onTouch,initialX: 300,initialY: 500}">
                                    <radio-svg-map :map="World" :class="{ 'disabled': !dest_lang }" v-model="selectedLocation" @click="onClick" style="margin-top: 40%;"/>
                                </panZoom>
                            </div>

                            <div v-if="hidden" style="height: 100%;">
                                <b-alert
                                    :show="dismissCountDown"
                                    dismissible
                                    variant="warning"
                                    @dismissed="dismissCountDown=0"
                                    @dismiss-count-down="countDownChanged"
                                    >
                                    <p>La lingua sorgente e/o la lingua di destinazione non sono state impostate correttamente.</p>
                                    <b-progress
                                        variant="warning"
                                        :max="dismissSecs"
                                        :value="dismissCountDown"
                                        height="4px"
                                    ></b-progress>
                                </b-alert>

                                <div class="mappa-lang">

                                    <h1 class="text-left" style="color: orange; margin-top: 20px; cursor:pointer;" @click="indietro"><font-awesome-icon style="font-size: 30px;" icon="chevron-left" /> Indietro</h1>

                                    <br>

                                    <div v-if="selectedLang">
                                        <!-- <p style="color: orange; font-weight: bold;" class="text-left">{{selectedLang[0].country}}</p> -->
                                        <p style="color: orange; font-weight: bold;" class="text-left">{{selectedLocation}}</p>
                                        <hr>
                                        <!-- <div v-for="lang in selectedLang" :key="lang.id+'G'"> -->
                                        <div v-for="lang in selectedLang" :key="lang.id">

                                    <div class="dropdown">
                                    <div class="dropdown__header" @click="toggleDropdown($event, lang)">
                                        <p style="text-align:left;float:left;">{{lang.description}}</p>
                                        <i class="fa fa-angle-down" aria-hidden="true"><font-awesome-icon style="text-align:right;float:right; color: orange;" aria-hidden="true" icon="chevron-down" /></i>
                                        <i class="fa fa-angle-up" aria-hidden="true"><font-awesome-icon style="text-align:right;float:right; color: white;" aria-hidden="true" icon="chevron-up" /></i>
                                        <hr style="clear:both;"/>
                                    </div>
                                    
                                    <div class="dropdown__content" style="background-color: #f1f3f4; border-radius: 10px;">
                                        <b-row>
                                            <b-col>
                                                <audio controls="controls" style="margin-top: 20px;" :src="lang.blobUrl">
                                                Il tuo browser non supporta l'audio
                                                </audio>
                                                <hr>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="8">
                                                <div style="display: table; margin: 0 auto;">
                                                    <h4 class="text-left"><b>{{lang.question}}</b></h4>
                                                    <p style="color: grey; font-weight: bold;" class="text-left"><i><b>Is this your language?</b></i></p>
                                                </div>
                                            </b-col>
                                            <b-col cols="1">
                                            </b-col>
                                            <b-col cols="2" style="margin: auto;">
                                                <h1 style="color: orange; cursor: pointer; font-size: 20px;" class="text-left" @click="translate2(lang)">
                                                    <b>OK</b>
                                                </h1>
                                            </b-col>
                                            <b-col cols="1" style="margin: auto;">
                                            </b-col>
                                        </b-row>
                                    </div>
                                    </div>

                                    </div>
                                        
                                    </div>

                                    <div v-else>
                                        <h1 class="text-left" style="color: silver; font-weight: bold;">Non ci sono lingue disponibili per questo paese.</h1>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                    <div v-if="content === 'lista'" class="lista">
                        <v-select style="width: 60%; margin: auto; padding-top: 20px;" :options="langs" v-model="dest_lang" label="description" name="langs" placeholder="Seleziona la tua lingua"></v-select>
                        <div style="width: 90%; margin: auto;">
                            <h1 style="color: silver; padding-top: 50px;" class="text-left"><b>Seleziona <br>la lingua da tradurre </b></h1>
                            <br>
                            <p style="color: orange; font-weight: bold;" class="text-left">EUROPA</p>

                            <div v-for="lang in europeLangs" :key="lang.id+'A'">

                                <div class="dropdown">
                                <div class="dropdown__header" @click="toggleDropdown($event, lang)">
                                    <p style="text-align:left;float:left;">{{lang.description}}</p>
                                    <i class="fa fa-angle-down" aria-hidden="true"><font-awesome-icon style="text-align:right;float:right; color: orange;" aria-hidden="true" icon="chevron-down" /></i>
                                    <i class="fa fa-angle-up" aria-hidden="true"><font-awesome-icon style="text-align:right;float:right; color: white;" aria-hidden="true" icon="chevron-up" /></i>
                                    <hr style="clear:both;"/>
                                </div>
                                
                                <div class="dropdown__content" style="background-color: #f1f3f4; border-radius: 10px;">
                                    <b-row>
                                        <b-col>
                                            <audio controls="controls" style="margin-top: 20px;" :src="lang.blobUrl">
                                            Il tuo browser non supporta l'audio
                                            </audio>
                                            <hr>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="8">
                                            <div style="display: table; margin: 0 auto;">
                                                <h4 class="text-left"><b>{{lang.question}}</b></h4>
                                                <p style="color: grey; font-weight: bold;" class="text-left"><i><b>Is this your language?</b></i></p>
                                            </div>
                                        </b-col>
                                        <b-col cols="1">
                                        </b-col>
                                        <b-col cols="2" style="margin: auto;">
                                        <h1 style="color: orange; cursor: pointer; font-size: 20px;" class="text-left" @click="translate2(lang)">
                                                <b>OK</b>
                                            </h1>
                                        </b-col>
                                        <b-col cols="1">
                                        </b-col>
                                    </b-row>
                                </div>
                                </div>

                            </div>

                            <br>
                            <p style="color: orange; font-weight: bold;" class="text-left">AFRICA</p>

                            <div v-for="lang in africaLangs" :key="lang.id+'B'">

                                <div class="dropdown">
                                <div class="dropdown__header" @click="toggleDropdown($event, lang)">
                                    <p style="text-align:left;float:left;">{{lang.description}}</p>
                                    <i class="fa fa-angle-down" aria-hidden="true"><font-awesome-icon style="text-align:right;float:right; color: orange;" aria-hidden="true" icon="chevron-down" /></i>
                                    <i class="fa fa-angle-up" aria-hidden="true"><font-awesome-icon style="text-align:right;float:right; color: white;" aria-hidden="true" icon="chevron-up" /></i>
                                    <hr style="clear:both;"/>
                                </div>
                                
                                <div class="dropdown__content" style="background-color: #f1f3f4; border-radius: 10px;">
                                    <b-row>
                                        <b-col>
                                            <audio controls="controls" style="margin-top: 20px;" :src="lang.blobUrl">
                                            Il tuo browser non supporta l'audio
                                            </audio>
                                            <hr>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="8">
                                            <div style="display: table; margin: 0 auto;">
                                                <h4 class="text-left"><b>{{lang.question}}</b></h4>
                                                <p style="color: grey; font-weight: bold;" class="text-left"><i><b>Is this your language?</b></i></p>
                                            </div>
                                        </b-col>
                                        <b-col cols="1">
                                        </b-col>
                                        <b-col cols="2" style="margin: auto;">
                                            <h1 style="color: orange; cursor: pointer; font-size: 20px;" class="text-left" @click="translate2(lang)">
                                                <b>OK</b>
                                            </h1>
                                        </b-col>
                                        <b-col cols="1">
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>

                            </div>

                            <br>
                            <p style="color: orange; font-weight: bold;" class="text-left">ASIA</p>

                            <div v-for="lang in asiaLangs" :key="lang.id+'C'">

                                <div class="dropdown">
                                <div class="dropdown__header" @click="toggleDropdown($event, lang)">
                                    <p style="text-align:left;float:left;">{{lang.description}}</p>
                                    <i class="fa fa-angle-down" aria-hidden="true"><font-awesome-icon style="text-align:right;float:right; color: orange;" aria-hidden="true" icon="chevron-down" /></i>
                                    <i class="fa fa-angle-up" aria-hidden="true"><font-awesome-icon style="text-align:right;float:right; color: white;" aria-hidden="true" icon="chevron-up" /></i>
                                    <hr style="clear:both;"/>
                                </div>
                                
                                <div class="dropdown__content" style="background-color: #f1f3f4; border-radius: 10px;">
                                    <b-row>
                                        <b-col>
                                            <audio controls="controls" style="margin-top: 20px;" :src="lang.blobUrl">
                                            Il tuo browser non supporta l'audio
                                            </audio>
                                            <hr>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="8">
                                            <div style="display: table; margin: 0 auto;">
                                                <h4 class="text-left"><b>{{lang.question}}</b></h4>
                                                <p style="color: grey; font-weight: bold;" class="text-left"><i><b>Is this your language?</b></i></p>
                                            </div>
                                        </b-col>
                                        <b-col cols="1">
                                        </b-col>
                                        <b-col cols="2" style="margin: auto;">
                                            <h1 style="color: orange; cursor: pointer; font-size: 20px;" class="text-left" @click="translate2(lang)">
                                                <b>OK</b>
                                            </h1>
                                        </b-col>
                                        <b-col cols="1">
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>

                            </div>

                            <br>
                            <p style="color: orange; font-weight: bold;" class="text-left">AMERICA</p>

                            <div v-for="lang in americaLangs" :key="lang.id+'E'">

                                <div class="dropdown">
                                <div class="dropdown__header" @click="toggleDropdown($event, lang)">
                                    <p style="text-align:left;float:left;">{{lang.description}}</p>
                                    <i class="fa fa-angle-down" aria-hidden="true"><font-awesome-icon style="text-align:right;float:right; color: orange;" aria-hidden="true" icon="chevron-down" /></i>
                                    <i class="fa fa-angle-up" aria-hidden="true"><font-awesome-icon style="text-align:right;float:right; color: white;" aria-hidden="true" icon="chevron-up" /></i>
                                    <hr style="clear:both;"/>
                                </div>
                                
                                <div class="dropdown__content" style="background-color: #f1f3f4; border-radius: 10px;">
                                    <b-row>
                                        <b-col>
                                            <audio controls="controls" style="margin-top: 20px;" :src="lang.blobUrl">
                                            Il tuo browser non supporta l'audio
                                            </audio>
                                            <hr>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="8">
                                            <div style="display: table; margin: 0 auto;">
                                                <h4 class="text-left"><b>{{lang.question}}</b></h4>
                                                <p style="color: grey; font-weight: bold;" class="text-left"><i><b>Is this your language?</b></i></p>
                                            </div>
                                        </b-col>
                                        <b-col cols="1">
                                        </b-col>
                                        <b-col cols="2" style="margin: auto;">
                                            <h1 style="color: orange; cursor: pointer; font-size: 20px;" class="text-left" @click="translate2(lang)">
                                                <b>OK</b>
                                            </h1>
                                        </b-col>
                                        <b-col cols="1">
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>

                            </div>

                                                            <br>
                            <p style="color: orange; font-weight: bold;" class="text-left">OCEANIA</p>

                            <div v-for="lang in oceaniaLangs" :key="lang.id+'F'">

                                <div class="dropdown">
                                <div class="dropdown__header" @click="toggleDropdown($event, lang)">
                                    <p style="text-align:left;float:left;">{{lang.description}}</p>
                                    <i class="fa fa-angle-down" aria-hidden="true"><font-awesome-icon style="text-align:right;float:right; color: orange;" aria-hidden="true" icon="chevron-down" /></i>
                                    <i class="fa fa-angle-up" aria-hidden="true"><font-awesome-icon style="text-align:right;float:right; color: white;" aria-hidden="true" icon="chevron-up" /></i>
                                    <hr style="clear:both;"/>
                                </div>
                                
                                <div class="dropdown__content" style="background-color: #f1f3f4; border-radius: 10px;">
                                    <b-row>
                                        <b-col>
                                            <audio controls="controls" style="margin-top: 20px;" :src="lang.blobUrl">
                                            Il tuo browser non supporta l'audio
                                            </audio>
                                            <hr>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="8">
                                            <div style="display: table; margin: 0 auto;">
                                                <h4 class="text-left"><b>{{lang.question}}</b></h4>
                                                <p style="color: grey; font-weight: bold;" class="text-left"><i><b>Is this your language?</b></i></p>
                                            </div>
                                        </b-col>
                                        <b-col cols="1">
                                        </b-col>
                                        <b-col cols="2" style="margin: auto;">
                                            <h1 style="color: orange; cursor: pointer; font-size: 20px;" class="text-left" @click="translate2(lang)">
                                                <b>OK</b>
                                            </h1>
                                        </b-col>
                                        <b-col cols="1">
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>

                            </div>
                        </div>
                    </div>

                    <div v-if="content === 'help'" class="help">
                            <h1 style="color: silver; margin-top: 20px;" class="text-left"><b>Scelta della lingua</b></h1>
                            <br>
                            <b-row>
                                <b-col cols="4" style="margin: auto;"> <img src="/img/img1.png" class="img-fluid mt-2" /> </b-col>
                                <b-col cols="7" style="padding-right: 3rem;">
                                    <b-row>
                                        <h3 style="color: orange;"><b>RICERCA SU MAPPA</b></h3>
                                    </b-row>
                                    <b-row>
                                        <p class="text-left">Nel caso non sia possibile individuare la lingua dell’interlocutore, 
                                        è possibile partire dalla navigazione di una mappa dove 
                                        si può scegliere la zona dalla quale si pensa che provenga la persona.</p>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <br>
                            <b-row>
                                    <b-col cols="1">
                                        <b-badge pill variant="primary">1</b-badge>
                                    </b-col>
                                    <b-col>
                                    <p class="text-left">Scegliere la propria lingua dal menu a tendina;</p>
                                    </b-col>
                            </b-row>
                            <br>
                            <b-row>
                                    <b-col cols="1">
                                        <b-badge pill variant="primary">2</b-badge>
                                    </b-col>
                                    <b-col>
                                    <p class="text-left">Navigare la mappa e selezionare la zona/il paese;</p>
                                    </b-col>
                            </b-row>
                            <br>
                            <b-row>
                                    <b-col cols="1">
                                        <b-badge pill variant="primary">3</b-badge>
                                    </b-col>
                                    <b-col>
                                    <p class="text-left">Scorrendo la lista delle lingue disponibili per quella zona, 
                                        cliccando su ciascuna voce si aprirà una tendina di dettaglio dove ascoltare una 
                                        breve clip audio che chiede la domanda «È questa la tua lingua?» riprodotta nella 
                                        lingua corrispondente; sarà presente anche la relativa traslitterazione sia in originale 
                                        che in inglese.</p>
                                    </b-col>
                            </b-row>
                            <br>
                            <b-row>
                                    <b-col cols="1">
                                        <b-badge pill variant="primary">4</b-badge>
                                    </b-col>
                                    <b-col>
                                    <p class="text-left">Cliccando ok si aprirà il tool di traduzione vocale.</p>
                                    </b-col>
                            </b-row>
                            <br>
                            <b-row>
                                <b-col cols="4" style="margin: auto;"> <img src="/img/img2.png" class="img-fluid mt-2" /> </b-col>
                                <b-col cols="7" style="padding-right: 3rem;">
                                    <b-row>
                                        <h3 style="color: orange;"><b>SCELTA DA LISTA</b></h3>
                                    </b-row>
                                    <b-row>
                                        <p class="text-left">Nel caso sia abbia la certezza del tipo di lingua da dover tradurre, 
                                            per rapidità è possibile sceglierla direttamente da una lista suddivisa per continenti, 
                                            dopo aver impostato la propria dal menu a tendina.</p>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <br>
                            <h1 style="color: silver; margin-top: 20px;" class="text-left"><b>Interazione e traduzione</b></h1>
                            <br>
                            <p class="text-left">Il tool di traduzione vocale permette di interagire con l’interlocutore registrando (alternativamente, per ciascuna lingua) 
                                la frase da dover tradurre e ottenendo subito la clip corrispondente con la traduzione vocale.</p>
                            <br>
                            <p class="text-left">Ad ogni registrazione effettuata (indicata con un fumetto) corrisponderà una singola traduzione 
                                (che apparirà in un riquadro a fianco del fumetto)</p>
                            <br>
                            <b-img src="/img/img3.png" class="img-fluid mt-2" center fluid/>
                            <br>
                            <b-row>
                                <b-col cols="4" style="margin: auto;"> <img src="/img/img4.png" class="img-fluid mt-2" /> </b-col>
                                <b-col cols="7" style="padding-right: 3rem;">
                                    <b-row>
                                        <h3 style="color: orange;"><b>CONVERSAZIONE CONTINUA</b></h3>
                                    </b-row>
                                    <b-row>
                                        <p class="text-left">È possibile attivare la modalità “conversazione” cliccando 
                                            l’icona corrispodente in basso, per poter ascoltare in una lingua (o nell’altra) 
                                            il discorso continuativo formato da registrazioni e traduzione. Per tornare al tool 
                                            di traduzione è sufficiente ricliccare l’icona.</p>
                                    </b-row>
                                </b-col>
                            </b-row>



                    </div>
            </b-row>

            <b-row id="footer">
                <div v-if="selLanguages" class="text-center" style="width: 100%;">
                    <div v-if="hidden">
                        <b-button v-if="traduci" variant="success" style="cursor: pointer;" @click="translate2">Avanti</b-button>
                    </div>
                    <hr class="mt-0">
                    <b-row>
                    <b-col>
                        <a :class="{ 'text-primary': isMapActive, 'inactive': !isMapActive}" @click="setMappa" style="cursor:pointer; font-weight: bold;"><font-awesome-icon icon="map" style="font-size: 25px;"/> <br>Mappa</a>
                    </b-col>
                    <b-col>
                        <a :class="{ 'text-primary': isListActive, 'inactive': !isListActive }" @click="setLista" style="cursor:pointer; font-weight: bold;"><font-awesome-icon icon="list-ul" style="font-size: 25px;"/> <br>Lista</a>
                    </b-col>
                    <b-col>
                        <a :class="{ 'text-primary': isHelpActive, 'inactive': !isHelpActive }" @click="setHelp" style="cursor:pointer; font-weight: bold;"><font-awesome-icon icon="question" style="font-size: 25px;"/> <br>Help</a>
                    </b-col>
                    </b-row>
                </div>
            </b-row>
        </b-container>

        <b-container fluid v-if="!selLanguages" style="height: 100%; position: relative; display: block;">
                <!-- <b-row style="height: 12%;">
                        <div style="width: 100%; background-color: #35a5dd; display: flex;">
                                            
                                <b-col fluid cols="2" style="margin:auto;">
                                    <VueRecordAudio mode="hold" @result="srcRecord" class="mx-auto" />
                                </b-col>
                                <b-col cols="7">
                                    <h1 style="color: white;" class="center-vertical"><b> {{src_lang.description}}</b></h1>
                                </b-col>
                                <b-col cols="2" style="margin:auto;">
                                <button id="endBtn" @click="endCom">Fine</button>
                                </b-col>

                        </div>
                </b-row>
                <b-row style="height: 82%;">
                    <div style="width: 100%; height: 100%; overflow-y: auto;">

                        <div v-if="i===0">
                            <h1 id="lang_select" style="color: silver;">
                                <b>Tieni premuto uno
                                dei due microfoni
                                per iniziare a registrare la conversazione
                                e ottenere la traduzione</b>
                            </h1>
                        </div>
                        
                        <div v-else style="height: 100%;">
                            <br>
                            <div v-for="blob in this.src_audioBlob" :key="blob.id"
                            style="
                            width: 100%;
                            height: 22%;
                            padding: 1%;">
                            <b-row style="height: 100%;">
                                <b-col cols="12">
                                    <div v-if="blob.src" class="vocal" style="float: left;">
                                        
                                        <b-tabs pills fill>
                                            <b-tab :title="src_lang.description">
                                                <audio style="width: 90%;" controls="controls" :src="blob.blobSrc">
                                                    Il tuo browser non supporta l'audio
                                                </audio>
                                            </b-tab>
                                            <b-tab active :title="dest_lang.description">
                                                <p v-if="!blob.blobDest" style="margin: auto; padding: 1%;" class="text-left" ><b>Sto traducendo...</b> <b-spinner small></b-spinner> </p>
                                                <audio v-else style="width: 90%;" controls="controls" :src="blob.blobDest">
                                                    Il tuo browser non supporta l'audio
                                                </audio>
                                            </b-tab>
                                        </b-tabs>

                                    </div>

                                    <div v-else class="vocal" style="float: right;">
                                        
                                        <b-tabs pills fill>
                                            <b-tab :title="src_lang.description" active>
                                                <p v-if="!blob.blobSrc" style="margin: auto; padding: 1%;" class="text-left" ><b>Sto traducendo...</b> <b-spinner small></b-spinner> </p>
                                                <audio v-else style="width: 90%;" controls="controls" :src="blob.blobSrc">
                                                    Il tuo browser non supporta l'audio
                                                </audio>
                                            </b-tab>
                                            <b-tab :title="dest_lang.description">
                                                <audio style="width: 90%;" controls="controls" :src="blob.blobDest">
                                                    Il tuo browser non supporta l'audio
                                                </audio>
                                            </b-tab>
                                        </b-tabs>

                                    </div>

                                </b-col>

                            </b-row>
                            </div>

                            <div v-for="blob in this.dest_audioBlob" :key="blob.id">
                                <audio controls="controls" :src="blob.blob">
                                    Il tuo browser non supporta l'audio
                                </audio>
                                <span style="color: gray;">{{blob.time}}</span>
                            </div>
                        </div>
                                            
                    </div>
                </b-row>
                <b-row style="height: 12%;">
                    <div style="width: 100%; background-color:#f1f3f4; z-index: 1;">
                        <div style="width: 100%; height: 100%; right: 0; margin-left: auto;">
                            <b-row style="height: 100%; margin: auto;">
                                <b-col cols="10" style="margin:auto;">
                                    <b-row><h1 style="color: grey; width: 100%" class="text-right"><b>{{dest_lang.description}}</b></h1></b-row>
                                    <b-row><h5 style="color: grey; width: 100%" class="text-right"><b><i>Operatore: {{user.first_name}} {{user.last_name}}</i></b></h5></b-row>
                                </b-col>
                                <b-col fluid cols="2" style="margin:auto;">
                                    <b-row>
                                        <VueRecordAudio mode="hold" @result="destRecord" class="mx-auto" style="background-color: orange;" /><br>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </b-row> -->
                <div class="user">
                    <b-col fluid cols="2" style="margin:auto;">
                        <VueRecordAudio mode="hold" @result="srcRecord" class="mx-auto" />
                    </b-col>
                    <b-col cols="7">
                        <h1 style="color: white;" class="center-vertical"><b> {{src_lang.description}}</b></h1>
                    </b-col>
                    <b-col cols="2" style="margin:auto;">
                    <button id="endBtn" @click="endCom">Fine</button>
                    </b-col>
                </div>
                <div class="traduzioni">
                    <div v-if="i===0">
                        <h1 id="lang_select" style="color: silver;">
                            <b>Tieni premuto uno
                            dei due microfoni
                            per iniziare a registrare la conversazione
                            e ottenere la traduzione</b>
                        </h1>
                    </div>
                    <div v-else style="height: 100%;">
                            <br>
                            <div v-for="blob in this.src_audioBlob" :key="blob.id"
                            style="
                            width: 100%;
                            height: 22%;
                            padding: 1%;">
                            <b-row style="height: 100%;">
                                <b-col cols="12">
                                    <div v-if="blob.src" class="vocal" style="float: left;">
                                        
                                        <b-tabs pills fill>
                                            <b-tab :title="src_lang.description">
                                                <audio style="width: 90%;" controls="controls" :src="blob.blobSrc">
                                                    Il tuo browser non supporta l'audio
                                                </audio>
                                            </b-tab>
                                            <b-tab active :title="dest_lang.description">
                                                <p v-if="!blob.blobDest" style="margin: auto; padding: 1%;" class="text-left" ><b>Sto traducendo...</b> <b-spinner small></b-spinner> </p>
                                                <audio v-else style="width: 90%;" controls="controls" :src="blob.blobDest">
                                                    Il tuo browser non supporta l'audio
                                                </audio>
                                            </b-tab>
                                        </b-tabs>

                                    </div>

                                    <div v-else class="vocal" style="float: right;">
                                        
                                        <b-tabs pills fill>
                                            <b-tab :title="src_lang.description" active>
                                                <p v-if="!blob.blobSrc" style="margin: auto; padding: 1%;" class="text-left" ><b>Sto traducendo...</b> <b-spinner small></b-spinner> </p>
                                                <audio v-else style="width: 90%;" controls="controls" :src="blob.blobSrc">
                                                    Il tuo browser non supporta l'audio
                                                </audio>
                                            </b-tab>
                                            <b-tab :title="dest_lang.description">
                                                <audio style="width: 90%;" controls="controls" :src="blob.blobDest">
                                                    Il tuo browser non supporta l'audio
                                                </audio>
                                            </b-tab>
                                        </b-tabs>

                                    </div>

                                </b-col>

                            </b-row>
                            </div>

                            <div v-for="blob in this.dest_audioBlob" :key="blob.id">
                                <audio controls="controls" :src="blob.blob">
                                    Il tuo browser non supporta l'audio
                                </audio>
                                <span style="color: gray;">{{blob.time}}</span>
                            </div>
                        </div>
                </div>
                <div class="operatore">
                    <b-row style="height: 100%; margin: auto;">
                        <b-col cols="10" style="margin:auto;">
                            <b-row><h1 style="color: grey; width: 100%" class="text-right"><b>{{dest_lang.description}}</b></h1></b-row>
                            <b-row><h5 style="color: grey; width: 100%" class="text-right"><b><i>Operatore: {{user.first_name}} {{user.last_name}}</i></b></h5></b-row>
                        </b-col>
                        <b-col fluid cols="2" style="margin:auto;">
                            <b-row>
                                <VueRecordAudio mode="hold" @result="destRecord" class="mx-auto" style="background-color: orange;" /><br>
                            </b-row>
                        </b-col>
                    </b-row>
                </div>

            <!-- <div v-if="mod == 'textToText'" style="height: 100%;">
                <b-row>
                        <div style="width: 100%; background-color: #35a5dd; display: flex;">
                                            
                                            <b-row style="width: 100%;">
                                                <b-col cols="2" style="margin-left:auto;">
                                                    <h1 style="color: white;" class="center-vertical"><b> {{src_lang.description}}</b></h1>
                                                </b-col>
                                                <b-col cols="5" style="margin: auto;">
                                                    <b-form-input v-if="placeholder" style="margin: auto;" v-model="textSrc" @keyup.enter="submitSrc" :placeholder="placeholder"></b-form-input>
                                                    <b-form-input v-else style="margin: auto;" v-model="textSrc" @keyup.enter="submitSrc" placeholder="Sto traducendo..."></b-form-input>
                                                </b-col>
                                                <b-col cols="2" style="margin:auto;">
                                                    <button id="endBtn" @click="endCom">Fine</button>
                                                </b-col>

                                            </b-row>

                        </div>
                </b-row>
                <b-row style="height: 83%;">
                    <div style="width: 100%; height: 100%; overflow-y: auto;">
                                            <div style="height: 100%;">
                                                <br>
                                                <div v-for="text in this.text" :key="text.id"
                                                style="
                                                width: 100%;
                                                height: 22%;
                                                padding: 1%;">
                                                <b-row style="height: 100%;">
                                                    <b-col cols="12">
                                                        <div v-if="text.src" class="vocal" style="float: left;">
                                                            
                                                            <b-tabs pills card fill>
                                                                <b-tab :title="src_lang.description">
                                                                    <p style="margin: auto; padding: 1%;" class="text-left" >{{text.original}}</p>
                                                                </b-tab>
                                                                <b-tab :title="dest_lang.description" active>
                                                                    <p v-if="!text.translated" style="margin: auto; padding: 1%;" class="text-left" ><b>Sto traducendo...</b> <b-spinner small></b-spinner> </p>
                                                                    <p v-else style="margin: auto; padding: 1%;" class="text-left" >{{text.translated}}</p>
                                                                </b-tab>
                                                            </b-tabs>

                                                        </div>

                                                        <div v-else class="vocal" style="float: right;">
                                                            <b-tabs pills card fill>
                                                                    <b-tab :title="src_lang.description" active>
                                                                        <p v-if="!text.translated" style="margin: auto; padding: 1%;" class="text-left" ><b>Sto traducendo...</b> <b-spinner small></b-spinner></p>
                                                                        <p v-else style="margin: auto; padding: 1%;" class="text-left" >{{text.translated}}</p>
                                                                    </b-tab>
                                                                    <b-tab :title="dest_lang.description">
                                                                        <p style="margin: auto; padding: 1%;" class="text-left" >{{text.original}}</p>
                                                                    </b-tab>
                                                            </b-tabs>
                                                        </div>

                                                    </b-col>

                                                </b-row>
                                                </div>

                                                <div v-for="blob in this.dest_audioBlob" :key="blob.id">
                                                    <audio controls="controls" :src="blob.blob">
                                                        Il tuo browser non supporta l'audio
                                                    </audio>
                                                    <span style="color: gray;">{{blob.time}}</span>
                                                </div>
                                            </div>
                                            
                    </div>
                </b-row>
                <b-row>
                    <div style="width: 100%; height: 12%; background-color:#f1f3f4;">
                                        <div style="width: 100%; height: 100%; right: 0; margin-left: auto;">
                                            <b-row style="height: 100%; margin: auto;">
                                                <b-col cols="8" style="margin: auto;">
                                                    <b-form-input style="margin: auto;" v-model="textDest" @keyup.enter="submitDest" placeholder="Inizia a scrivere per iniziare la conversazione e ottenere la traduzione."></b-form-input>
                                                </b-col>
                                                <b-col cols="3" style="margin:auto;">
                                                    <b-row><h1 style="color: grey; width: 100%" class="text-right"><b>{{dest_lang.description}}</b></h1></b-row>
                                                    <b-row><h5 style="color: grey; width: 100%" class="text-right"><b><i>Operatore: {{user.first_name}} {{user.last_name}}</i></b></h5></b-row>
                                                </b-col>
                                                <b-col cols="1"></b-col>
                                            </b-row>
                                        </div>
                    </div>
                </b-row>
            </div> -->
        </b-container>
        

    </div>
    
</template>
<script>
import UserService from "@/services/user.service";
import { RadioSvgMap } from "vue-svg-map";
import World from "@svg-maps/continents";
export default {
  name: "VoiceToVoice",
  components: { RadioSvgMap },
  props: ['mod'],
  data(){
   return {
    noTranslate: 'Nessuna traduzione disponibile',
    dismissSecs: 5,
    dismissCountDown: 0,
    showDismissibleAlert: false,
    content: 'mappa',
    langs: [],
    World,
    dest_lang: null,
    src_lang: null,
    onTouch: function() {
        return false;
    },
    selectedLang: [],
    countryLangs: [],
    europeLangs: [],
    africaLangs: [],
    asiaLangs: [],
    canadaLangs: [],
    americaLangs: [],
    oceaniaLangs: [],
    src_audioBlob: [],
    dest_audioBlob: [],
    selectedLocation: null,
    mapSelected: false,
    hidden: false,
    traduci: false,
    selLanguages: true,
    user: null,
    i: 0,
    id: null,
    last_event: null,
    isMapActive: true,
    isListActive: false,
    isHelpActive: false,
    userSpinnerShow: false,
    orgSpinnerShow: false,
    textSrc: null,
    textDest: null,
    text: null,
    placeholder: null,
   } 
  },
  methods: {
    async submitSrc(){
        //alert('submit: '+this.textSrc);
        if(this.text == null)
            this.text = [];
        this.text.push({
            src: true,
            langIn: this.src_lang.id,
            langOut: this.dest_lang.id,
            original: this.textSrc, 
            translated: undefined,
        });

        await UserService.textToText(this.src_lang.id,this.dest_lang.id, 'no_save', this.textSrc).then(response => {
            if (response.status == 500)
                return 'errore'
            else
                return response.json();
            }).then(data => {
                this.text[this.i++].translated = data.translated;
        })

        this.textSrc = null;
    },
    async submitDest(){
        if(this.text == null)
            this.text = [];
        this.text.push({
            src: false,
            langIn: this.dest_lang.id,
            langOut: this.src_lang.id,
            original: this.textDest, 
            translated: undefined,
            });

        await UserService.textToText(this.dest_lang.id,this.src_lang.id, 'no_save', this.textDest).then(response => {
                if (response.status == 500)
                    return 'errore'
                else
                    return response.json();
            }).then(data => {
                this.text[this.i++].translated = data.translated;
        })

        this.textDest = null;
    },
    endCom(){
        UserService.removeAudio(this.id).then((response) => {
            console.log(response);
          this.$router.go();
        });
    },
    resetDestLang(){
        this.dest_lang = null;
    },
     toggleDropdown (event, lang = undefined) {
        //if(event.path[0].className == "dropdown__header is-active"){
        if(event.target.className == "dropdown__header is-active"){
            event.currentTarget.classList.toggle('is-active');
            return;
        }
        event.currentTarget.classList.toggle('is-active');
        if (!lang.blobUrl){
             UserService.textToSpeech(lang.id, 'yes').then(response => {
            if(response.status == 405)
              return response;
            else
              return response.blob();
          }).then(data => {
            if(data.status == 405){
              this.$bvToast.toast(data.statusText, {
              title: "Errore "+data.status,
              autoHideDelay: 4000,
              solid: true,
              variant:'danger',
              appendToast: false
              });
              lang.blobUrl = 'traduzione non disponibile';
              return 0;
            }
            lang.blobUrl = URL.createObjectURL(data);
          
          });
        }
        if(!lang.question){
             UserService.textToText(this.dest_lang.id, lang.id).then(response => {
                if (response.status == 500)
                    return 'errore'
                else
                    return response.json();
            }).then(data => {
                let msgToSet;
                if(data == 'errore')
                    msgToSet = this.noTranslate;
                else
                    msgToSet = data.translated;
                
                lang.question = msgToSet
            })
        }
    },
    countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert() {
        this.dismissCountDown = this.dismissSecs
    },
    translate(){
        this.hidden = !this.hidden;
    },
    translate2(lang = null){
        if(lang.id){
            this.src_lang = lang;
        }
        if(this.src_lang == undefined || this.dest_lang == undefined)
        {   
            //this.showAlert();
            this.$bvToast.toast(`Non hai impostato le lingue correttamente`, {
                title: `Errore`,
                autoHideDelay: 2000,
                solid: true,
                variant:'danger',
                appendToast: false
            });
        }
        else{

            UserService.textToText(this.dest_lang.id,this.src_lang.id, 'no_save', 'Inizia a scrivere per iniziare la conversazione e ottenere la traduzione.').then(response => {
            console.log(response);
            if (response.status == 500)
                return 'errore'
            else
                return response.json();
            }).then(data => {
                console.log(data);
                this.placeholder = data.translated;
            })

            this.content = !this.selLanguages;
            this.traduci = false;
            this.mapSelected = false;
            this.selLanguages = !this.selLanguages;
            this.id = Math.ceil(Math.random()*10000);
        }
    },
    indietro(){
        this.selectedLang = [],
        this.traduci = false;
        this.hidden = !this.hidden;
    },
    setUserStorageLanguage(event){
        localStorage.setItem('dest_lang', JSON.stringify(event));
    },
    setMappa(){
        this.selectedLang.isMap = true,
        this.content = 'mappa';
        this.isMapActive = true;
        this.isListActive = false;
        this.isHelpActive = false;
    },
    setLista(){
        this.selectedLang.isMap = false,
        this.content = 'lista';
        this.isMapActive = false;
        this.isListActive = true;
        this.isHelpActive = false;
    },
    setHelp(){
        this.content = 'help';
        this.isMapActive = false;
        this.isListActive = false;
        this.isHelpActive = true;
    },
    setDestLang(id){
        this.src_lang = id;
        this.traduci = !this.traduci;
    },
    async onClick(){
        // await UserService.getCountryLanguages(this.selectedLocation).then((response) => {
        //     if(response.data.length == 0)
        //         this.selectedLang = null;
        //     else{
        //         this.selectedLang.isMap = true;
        //         response.data.forEach(element => {
        //             this.selectedLang.push({
        //                 country: element.country,
        //                 continent: element.continent,
        //                 default_flag: element.default_flag,
        //                 description: element.description,
        //                 id: element.id,
        //                 question: element.question?element.question:undefined,
        //                 blobUrl: undefined
        //             });
        //         });
        //         }
        // });
        if(this.selectedLocation == 'europe'){
            this.selectedLocation = 'Europa';
            this.selectedLang = this.europeLangs;
        }
        if(this.selectedLocation == 'africa'){
            this.selectedLocation = 'Africa';
            this.selectedLang = this.africaLangs;
        }
        if(this.selectedLocation == 'asia'){
            this.selectedLocation = 'Asia';
            this.selectedLang = this.asiaLangs;
        }
        if(this.selectedLocation == 'oceania'){
            this.selectedLocation = 'Oceania';
            this.selectedLang = this.oceaniaLangs;
        }
        if(this.selectedLocation == 'america'){
            this.selectedLocation = 'America';
            this.selectedLang = this.americaLangs;
        }
        this.mapSelected = true;
        this.hidden = !this.hidden;

    },
    async srcRecord(msg) {
        const today = new Date();
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        const time2 = today.getHours() + "-" + today.getMinutes() + "-" + today.getSeconds();
        this.src_audioBlob.push({id: this.i++,blobSrc: URL.createObjectURL(msg), time: time, blobDest: undefined, src: true});
        UserService.uploadAudio(this.src_lang.id, this.dest_lang.id, this.id, time2, msg, this.i).then(response => {
            UserService.getAudio(response.data.audioRes).then(response =>{
              if(response.ok == false){
                return 'errore';
              }
              return response.blob();
            }).then(data=>{
              if(data.size == 1 || data == 'errore'){
                this.src_audioBlob[this.i-1].blobDest = 'errore nella traduzione';
                this.$bvToast.toast(`Errore nella traduzione dell'audio. Riprova.`, {
                title: `Errore`,
                autoHideDelay: 4000,
                solid: true,
                variant:'danger',
                appendToast: false
                })
              }
              else{
              this.src_audioBlob[this.i-1].blobDest = URL.createObjectURL(data);
              }
            });

        });

    },
    srcaudioBlobUrl(blob){
        return URL.createObjectURL(blob);
    },
    destaudioBlobUrl(blob) {
        return URL.createObjectURL(blob);
    },
    async destRecord(msg) {
        const today = new Date();
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        const time2 = today.getHours() + "-" + today.getMinutes() + "-" + today.getSeconds();
        this.src_audioBlob.push({id: this.i++,blobSrc: undefined, time: time, blobDest: URL.createObjectURL(msg), src: false});

        UserService.uploadAudio(this.dest_lang.id, this.src_lang.id, this.id, time2, msg, this.i).then(response => {
            UserService.getAudio(response.data.audioRes).then(response =>{
              if(response.ok == false){
                return 'errore';
              }
              return response.blob();
            }).then(data=>{
              this.src_audioBlob[this.i-1].blobSrc = 'errore nella traduzione';
              if(data.size == 1 || data == 'errore'){
                this.$bvToast.toast(`Errore nella traduzione dell'audio. Riprova.`, {
                title: `Errore`,
                autoHideDelay: 4000,
                solid: true,
                variant:'danger',
                appendToast: false
                })
              }
              else{
                this.src_audioBlob[this.i-1].blobSrc = URL.createObjectURL(data);
              }
            });

        });

    },
    async getLang(langs, country, sendRequest = 'no'){
        for (const id of langs){

          await UserService.textToSpeech(id.id, sendRequest).then(response => {
            if(response.status == 405)
              return response;
            else
              return response.blob();
          }).then(data => {
            if(data.status == 405){
              this.$bvToast.toast(data.statusText, {
              title: "Errore "+data.status,
              autoHideDelay: 4000,
              solid: true,
              variant:'danger',
              appendToast: false
              })
              return 0;
            }
            if (country == 'europe'){
                this.europeLangs.push({
                    country: id.country,
                    continent: id.continent,
                    default_flag: id.default_flag,
                    description: id.description,
                    id: id.id,
                    question: id.question?id.question:this.noTranslate,
                    blobUrl: URL.createObjectURL(data)
                });
            }
            else if (country == 'africa'){
                this.africaLangs.push({
                    country: id.country,
                    continent: id.continent,
                    default_flag: id.default_flag,
                    description: id.description,
                    id: id.id,
                    question: id.question?id.question:this.noTranslate,
                    blobUrl: URL.createObjectURL(data)
                });
            }
            else if (country == 'asia'){
                this.asiaLangs.push({
                    country: id.country,
                    continent: id.continent,
                    default_flag: id.default_flag,
                    description: id.description,
                    id: id.id,
                    question: id.question?id.question:this.noTranslate,
                    blobUrl: URL.createObjectURL(data)
                });
            }

            else {
                this.selectedLang.push({
                    country: id.country,
                    continent: id.continent,
                    default_flag: id.default_flag,
                    description: id.description,
                    id: id.id,
                    question: id.question?id.question:this.noTranslate,
                    blobUrl: URL.createObjectURL(data)
                });
            }

          });
        }
        this.show = false;
    }
  },
  mounted() {
    UserService.whoAmI()
    .then((response) => {
        this.user = response.data;
        UserService.getOrganizationById(this.user.organization_id).then((response) => (this.organization = response.data));
    })
    .catch((error) => {
        console.log("Whoami: error");
        console.log(error);
        this.$store.dispatch("auth/logout");
        this.$router.push("/login/organization");
    });

    UserService.getLanguages(true).then((response) => (this.langs = response.data));

    UserService.getCountryLanguages('europe').then((response) => {
        response.data.forEach(element => {
        let insert = true;
        this.europeLangs.forEach(element2 => {
            if(element.id == element2.id)
                insert = false;
                //console.log(element.id+' '+element2.id);
            });
        if (insert)
            this.europeLangs.push({
                country: element.country,
                continent: element.continent,
                default_flag: element.default_flag,
                description: element.description,
                id: element.id,
                question: element.question?element.question:undefined,
                blobUrl: undefined
            });
            
        });
    });

    UserService.getCountryLanguages('africa').then((response) => {
        response.data.forEach(element => {
        let insert = true;
        this.africaLangs.forEach(element2 => {
            if(element.id == element2.id)
                insert = false;
                //console.log(element.id+' '+element2.id);
            });
        if (insert)
            this.africaLangs.push({
                country: element.country,
                continent: element.continent,
                default_flag: element.default_flag,
                description: element.description,
                id: element.id,
                question: element.question?element.question:undefined,
                blobUrl: undefined
            });
            
        });
    });

    UserService.getCountryLanguages('asia').then((response) => {
        response.data.forEach(element => {
        let insert = true;
        this.asiaLangs.forEach(element2 => {
            if(element.id == element2.id)
                insert = false;
                //console.log(element.id+' '+element2.id);
            });
        if (insert)
            this.asiaLangs.push({
                country: element.country,
                continent: element.continent,
                default_flag: element.default_flag,
                description: element.description,
                id: element.id,
                question: element.question?element.question:undefined,
                blobUrl: undefined
            });
            
        });
    });

    UserService.getCountryLanguages('canada').then((response) => {
        response.data.forEach(element => {
        let insert = true;
        this.canadaLangs.forEach(element2 => {
            if(element.id == element2.id)
                insert = false;
                //console.log(element.id+' '+element2.id);
            });
        if (insert)
            this.canadaLangs.push({
                country: element.country,
                continent: element.continent,
                default_flag: element.default_flag,
                description: element.description,
                id: element.id,
                question: element.question?element.question:undefined,
                blobUrl: undefined
            });
            
        });
    });

    UserService.getCountryLanguages('america').then((response) => {
        response.data.forEach(element => {
        let insert = true;
        this.americaLangs.forEach(element2 => {
            if(element.id == element2.id)
                insert = false;
                //console.log(element.id+' '+element2.id);
            });
        if (insert)
            this.americaLangs.push({
                country: element.country,
                continent: element.continent,
                default_flag: element.default_flag,
                description: element.description,
                id: element.id,
                question: element.question?element.question:undefined,
                blobUrl: undefined
            });
            
        });
    });

    UserService.getCountryLanguages('oceania').then((response) => {
        response.data.forEach(element => {
            let insert = true;
            this.oceaniaLangs.forEach(element2 => {
                if(element.id == element2.id)
                    insert = false;
                    //console.log(element.id+' '+element2.id);
            });
            if (insert)
                this.oceaniaLangs.push({
                    country: element.country,
                    continent: element.continent,
                    default_flag: element.default_flag,
                    description: element.description,
                    id: element.id,
                    question: element.question?element.question:undefined,
                    blobUrl: undefined
                });
            
        });
        // response.data.forEach(element => {
        //     this.oceaniaLangs.push({
        //             country: element.country,
        //             continent: element.continent,
        //             default_flag: element.default_flag,
        //             description: element.description,
        //             id: element.id,
        //             question: element.question?element.question:undefined,
        //             blobUrl: undefined
        //         });
        // });
    });
    
    if(localStorage.dest_lang){
        this.dest_lang = JSON.parse(localStorage.dest_lang);
        //console.log(JSON.parse(localStorage.dest_lang));
    }

  }
};
</script>

<style>

.user{
    position: absolute;
    top: 0px;
    width: 100%;
    left:0px;
    height: 5rem;
    background-color: #35a5dd;
    display: flex;
}
.traduzioni {
    position: absolute;
    top: 5rem;
    bottom: 5rem;
    width: 100%;
    left: 0px;
    overflow-y: auto;
    overflow-x: hidden;
}
.operatore {
    position: absolute;
    height: 5rem;
    width: 100%;
    left: 0px;
    bottom: 0px;
    background-color:#f1f3f4;
}

#lang_select{
    width: 60%;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    /* background-color: white; */
    /* opacity: 0.3; */
}

p {
    font-size: 1em;
}

#content {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    height:100%;
    /* padding: 0 20px; */
}
#content > div {
    /* padding:70px 0; */
    padding-bottom: 5.5rem;
}

#footer {
    width:100%;
    bottom:0px;
    height: 4.5rem;
    position:fixed;
    margin-top: 0;
    overflow: hidden;
    background-color: white;
    z-index: 1;
}


#footer a:hover{
    color:#f4ac61;
}

#footer a.text-primary{
    pointer-events: none;
}

.disabled{
    pointer-events: none;
}
.help{
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    height: calc(93vh - 3.2rem);
    /* height: calc(98vh); */
    overflow-x: auto; 
    overflow-x: hidden;
}

.lista{
    height: calc(93vh - 3.2rem);
    width: 100%;
    overflow-y:auto;
}

.mappa-lang{
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    height: calc(93vh - 3.2rem);
    overflow-y: auto;
}
.inactive{
    color:grey;
}

.mappa{
    overflow-y: hidden; 
    height: calc(93vh - 3.2rem);
    width: 100%;
}
h1 b{
    font-size: 0.7em;
}

h5 b{
    font-size: 0.8em;
}
#endBtn{
    background-color: transparent;
    color: white;
    border: 2px solid white;
    border-radius: 10px;
    padding: 5%;
    width: 100%;
    font-weight: bold;
    transition: 0.3s;
}

#endBtn:hover{
    background-color: white;
    color: black;
    transition: 0.3s;
}

#v-select{
    position: absolute; 
    width: 100%;
    padding: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(255, 255, 255, 0.3)
}
.vocal {
    width: 60%; 
    height: 95%; 
    background-color: #f1f3f4; 
    border-radius: 20px;
}

@media (max-width: 768px) {
    b{
    font-size: 0.8em;
    }

    .vocal{
        width: 90%!important;
    }
}

@media (max-width: 1236px){
    .vocal{
        width: 70%;
    }
}

.vl {
  border-left: 1px solid silver;
  height: 30px;
  position: absolute;
  left: 50%;
  margin-left: -3px;
  top: 0;
  border-radius: 5px;
}

.center-vertical {
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
}
.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
<style lang="scss">
    .dropdown {
        &__header {
            cursor: pointer;
            line-height: 30px;
            padding-left: 10px;
            padding-right: 50px;
            position: relative;
            text-overflow: ellipsis;
            i.fa {
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
                transition: opacity .3s;
                &.fa-angle-up {
                    opacity: 0;
                }
            }
            &.is-active {
                border-radius: 5px;
                background-color: #35a5dd;
                p {
                    color: white;
                    font-weight: bold;
                }
                i.fa {
                    &.fa-angle-up {
                        opacity: 1;
                    }
                    &.fa-angle-down {
                        opacity: 0;
                    }
                }
                + .dropdown__content {
                    height: auto;
                    opacity: 1;
                    visibility: visible;
                }
            }
        }
        &__content {
            height: 0;
            opacity: 0;
            overflow: hidden;
            //padding: 15px 10px;
            transition: opacity .3s;
            visibility: hidden;
        }
    }
</style>
